import React from 'react';
import { makeStyles } from '@mui/styles';
import { Typography, Card, CardContent, CardActions, Button, Avatar, Badge} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const useStyles = makeStyles((theme) => ({
  welcomeText: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: theme.palette.primary.main, // You can use any color from the Material-UI theme
    marginBottom: theme.spacing(2),
  },
  engineerCount: {
    fontSize: '18px',
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(2),
  },
  recruitmentAgency: {
    fontSize: '16px',
    color: theme.palette.text.secondary,
  },
  cardContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    marginTop: theme.spacing(2),
  },
  card: {
    minWidth: 250,
    padding:20,
    marginBottom: theme.spacing(2),
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
    marginRight: theme.spacing(1),
  },
}));

const sectorsData = [
    { sector: 'Software Development', count: 500 },
    { sector: 'Mechanical Engineering', count: 350 },
    { sector: 'Electrical Engineering', count: 300 },
    // Add more sectors and counts as needed
  ];
  
const ClientHome = () => {
  const classes = useStyles();

  return (
    <div>
     <Card style={{
        padding:20,
        backgroundColor: 'white',
     }}>
      <Typography variant="h5" className={classes.welcomeText}>
        Welcome to RecruitsPlus Candidates Portal!
      </Typography>
      <Typography variant="body1" className={classes.engineerCount}>
        We pride ourselves on being your premier destination for top-notch talent in more than 50 + industries.
        With over 10000+ highly skilled and motivated candidates on board, and counting, we are dedicated to connecting
        you with the perfect match for your company's needs.
      </Typography>
      <Typography variant="body1" className={classes.recruitmentAgency}>
        At RecruitsPlus, we understand the significance of finding the right individuals to take your business to new heights.
        Our team of experienced and passionate recruitment experts is committed to providing tailored solutions that align
        with your company's goals and culture.
      </Typography>
    </Card>
      {/* <div className={classes.cardContainer}>
      {sectorsData.map((data, index) => (
        <Card key={index} className={classes.card}>
          <CardContent>
            <Typography variant="h6">{data.sector}</Typography>
            <Typography variant="body1">
              <Badge badgeContent={data.count} color="secondary">
                <Avatar className={classes.avatar}>
                  <AddIcon />
                </Avatar>
              </Badge>{" "} candidates in our database
            </Typography>
          </CardContent>
        </Card>
      ))}
    </div> */}
    </div>
  );
};

export default ClientHome;
